module.exports = __webpack_public_path__ + "media/hk_video_intro.da4bcaea.mp4";